'use client'

import ClauseHoverPreview from "@/components/HoverPreview"
import { getUrl, getDecisionUrl } from "@/lib/utils"
import Link from "next/link"

export default function RefLink ({ refLink: ref, hover = true }: { refLink: any, hover?: boolean }) {
  if (!hover) {
    return (
      <Link
        prefetch={false}
        href={(ref.documentType === 'decision' || ref.documentType === 'rechtssatz') ? getDecisionUrl(ref) : getUrl(ref.lawType, { norm: ref.abbreviation, enumeration: ref.enumeration !== '§ 0' ? ref.enumeration : undefined, abbrNr: ref.abbrNr })}
      >
        {ref.value}
      </Link>
    )
  }

  return (
    <ClauseHoverPreview
      id={ref.citation}
      render={(
        <Link
          prefetch={false}
          href={(ref.documentType === 'decision' || ref.documentType === 'rechtssatz') ? getDecisionUrl(ref) : getUrl(ref.lawType, { norm: ref.abbreviation, enumeration: ref.enumeration !== '§ 0' ? ref.enumeration : undefined, abbrNr: ref.abbrNr })}
        />
      )}
    >
      {ref.value}
    </ClauseHoverPreview>
  )
}
